import { useEffect, useState } from "react";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { InfoText, PaymentGatewayContainer } from "../machineInstalRequest/styles";
import { billSingularPay, machineInstallManualPay, temperatureInstallManualPay } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { payTypes } from "../../constants";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useAppSelector } from "../../redux/store/storehooks";

export const TemperatureManualPaymentDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(ManualPaymentForm) as any
    const myStore = useAppSelector((state) => state)
    const [FormState,SetFormState] = useState(0);
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [isSavingData,setIsSavingData] = useState(true);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{
        if (payLoad.bill !== null && payLoad.bankAccount !== null) setIsLoading(false);
    },[payLoad])

    const onSubmitForm = (e:any) => {
        e.preventDefault();
        
        let payment = values.amount ? Number(values.amount) : 0
        let reminder = payLoad.bill.int_BillAmount - payLoad.bill.int_TotalPay;

        if (reminder < payment || reminder==0) {
            errorNotify("مبلغ وارد شده مجاز نمی باشد. باقیمانده:" + reminder,undefined,5000)
            return;            
        }
       
  
        setIsSubmiting(true)
            temperatureInstallManualPay({
                requestId:payLoad.requestid,
                labId:payLoad.bill.prk_AndriodLab_AutoID,
                billId:payLoad.bill.prk_ParsicLabBill_AutoID,
                userId:myStore.auth.userId,
                bankAccount:values.bankAccount,
                payType:values.payType,
                payAmount: values.amount ? Number(values.amount) : 0,
                title: payLoad.temperatureName === "" ? "پرداخت دستی" : "نصب دماسنج " + payLoad.temperatureName,
                description:values.description ? values.description : "",
            })
            .then((result:any) => {
                sucessNotify("اطلاعات با موفقیت ثبت شد",undefined,5000)
                setIsSubmiting(false)
                onCancel();
            })
            .catch((error) => {
              console.log(error);
              setIsSubmiting(false)
              errorNotify(error.response.data.errorMessage,undefined,5000)
            })
        
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}
                {isLoading === false && (

                    <FormContainer title="پرداخت دستی فاکتور" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                        
                        {payLoad.bill !== undefined && (
                            <>
                                <Row>
                                    <InfoText>شماره فاکتور: {payLoad.bill.prk_ParsicLabBill_AutoID ? payLoad.bill.prk_ParsicLabBill_AutoID : 0}</InfoText>
                                </Row>

                                <Row>
                                <InfoText>مبلغ کل فاکتور: {payLoad.bill.int_BillAmount ? payLoad.bill.int_BillAmount.toLocaleString() : 0}</InfoText>
                                </Row>

                                <Row>
                                <InfoText> مبلغ پرداخت شده : {payLoad.bill.int_TotalPay ? payLoad.bill.int_TotalPay.toLocaleString() : 0}</InfoText>
                                </Row>

                                <Row>
                                <InfoText>باقیمانده: {payLoad.bill.int_BillAmount ?  (payLoad.bill.int_BillAmount - payLoad.bill.int_TotalPay).toLocaleString() : 0}</InfoText>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomSelect 
                                            name="bankAccount"
                                            placeholder="حساب بانکی"
                                            itemList={payLoad.bankAccount}
                                            value={values.bankAccount || ""}
                                            onChange={handleChange}
                                            valueObjectField={"prk_ParsicBankAccount_AutoID"}
                                            displayObjectField={"str_AccountTitle"}
                                        />
                                        <ValidationType type="bankAccount" />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomSelect
                                            name="payType"
                                            placeholder="نوع پرداخت"
                                            itemList={payTypes}
                                            value={values.payType || ""}
                                            onChange={handleChange}
                                            valueObjectField={"id"}
                                            displayObjectField={"title"}
                                        />
                                        <ValidationType type="payType" />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomTextArea
                                            name="amount"
                                            placeholder="مبلغ"
                                            value={values.amount || 0}
                                            onChange={handleChange}
                                        />
                                        <ValidationType type="amount" />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomTextArea
                                            name="description"
                                            placeholder="توضیحات"
                                            value={values.description || ""}
                                            onChange={handleChange}
                                        />
                                        <ValidationType type="description" />
                                    </Col>
                                </Row>

                            </>

                        )}
                        
                    </FormContainer>

                )}
            </>
            
        </Modal>
    )
}